import React from "react";
import { Card } from "react-bootstrap";
import MainCard from "../../../Components/Cards/MainCard";

const KPICard = ({ kpiData, cardConfig }) => {
  console.log(kpiData);
  const trendPositive = kpiData.trend.startsWith("+");
  const { icon, bgColor, iconColor } = cardConfig;
  return (
    <MainCard>
      <Card.Body className="d-flex flex-column justify-content-between p-0">
        {/* Top Row */}
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div className={`p-2 rounded ${bgColor} ${iconColor}`}>{icon}</div>
          <span
            className={`fw-semibold ${
              trendPositive ? "text-success" : "text-danger"
            }`}
          >
            {kpiData.trend}
          </span>
        </div>

        {/* Middle Row */}
        <h3 className="fw-bold text-dark mb-1">{kpiData.value}</h3>

        {/* Bottom Row */}
        <p className="text-muted small mb-0">{kpiData.title}</p>
      </Card.Body>
    </MainCard>
  );
};

export default KPICard;
